import React from 'react';

const ImageGallery = ({ images, title }) => {
  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div id="image-gallery-section">
      {title && (
        <h3 className="font-bold text-xl sm:text-2xl text-premium-dark mb-4 sm:mb-6">{title}</h3>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        {images.map((image, index) => (
          <div
            key={index}
            className="group relative overflow-hidden bg-premium-light cursor-pointer hover:opacity-90 transition-opacity aspect-square"
          >
            <img
              src={image.url || image}
              alt={image.alt || `Gallery image ${index + 1}`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            {image.label && (
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-premium-dark/90 to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="text-white font-medium text-sm">{image.label}</div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageGallery;
